import React from 'react'
import loadable from '@loadable/component'
import { createRegisterableComponent } from '@news-mono/web-common'

const LazyOurPublications = loadable(() => import('./our-publication'))

export const OurPublicationRegistration = createRegisterableComponent(
    'our-publications',
    () => <LazyOurPublications />,
)
